:root {
  color-scheme: light;
  --k-color-violet: #6d5ef8;
  --k-color-cyan: #22d3ee;
  --k-color-graphite: #0b1020;
  --k-color-paper: #fcfbf8;
  --k-color-mist: #f2f0ec;
  --k-color-ink: #17151d;
  --k-color-muted: #6f6a78;
  --k-color-success: #1b8a6b;
  --k-color-warning: #b46b20;
  --k-color-danger: #c44d5f;
  --k-space-1: 0.25rem;
  --k-space-2: 0.5rem;
  --k-space-3: 0.75rem;
  --k-space-4: 1rem;
  --k-space-5: 1.25rem;
  --k-space-6: 1.5rem;
  --k-space-8: 2rem;
  --k-space-10: 2.5rem;
  --k-space-12: 3rem;
  --k-space-16: 4rem;
  --k-radius-sm: 0.625rem;
  --k-radius-md: 1rem;
  --k-radius-lg: 1.5rem;
  --k-radius-pill: 999px;
  --k-shadow-soft: 0 10px 30px rgba(23, 21, 29, 0.08);
  --k-shadow-lift: 0 20px 60px rgba(23, 21, 29, 0.14);
  --k-font-display: Newsreader, Iowan Old Style, Baskerville, Georgia, serif;
  --k-font-ui: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  --k-motion-fast: 150ms;
  --k-motion-standard: 220ms;
  --k-motion-ease: cubic-bezier(0.22, 1, 0.36, 1);

  --color-bg: var(--k-color-paper);
  --color-surface: #ffffff;
  --color-surface-subtle: var(--k-color-mist);
  --color-primary: var(--brand-primary);
  --color-primary-strong: #5144d6;
  --color-accent: var(--brand-accent);
  --color-text: var(--k-color-ink);
  --color-text-muted: var(--k-color-muted);
  --color-border: #e4e0e7;
  --color-focus: #5144d6;
  --color-success: var(--k-color-success);
  --color-warning: var(--k-color-warning);
  --color-danger: var(--k-color-danger);
  --color-on-primary: #ffffff;
  --brand-primary-base: var(--k-color-violet);
  --brand-accent-base: var(--k-color-cyan);
  --brand-primary: var(--brand-primary-base);
  --brand-accent: var(--brand-accent-base);
  /* Inherited aliases let the framework-free widgets follow the active
     instance palette without coupling them to a particular app. */
  --kuroo-brand-primary: var(--brand-primary);
  --kuroo-brand-accent: var(--brand-accent);
}

:root[data-theme="dark"] {
  color-scheme: dark;
  --color-bg: #111017;
  --color-surface: #1b1922;
  --color-surface-subtle: #25222d;
  --brand-primary: color-mix(in srgb, var(--brand-primary-base) 42%, #ffffff);
  --color-primary: var(--brand-primary);
  --color-primary-strong: #b5adff;
  --brand-accent: color-mix(in srgb, var(--brand-accent-base) 52%, #ffffff);
  --color-accent: var(--brand-accent);
  --color-text: #f7f4f1;
  --color-text-muted: #b5afbd;
  --color-border: #383341;
  --color-focus: #c8c2ff;
  --color-on-primary: #17151d;
  --k-shadow-soft: 0 12px 34px rgba(0, 0, 0, 0.24);
  --k-shadow-lift: 0 24px 70px rgba(0, 0, 0, 0.36);
}

:root:not([data-theme-preference="light"]):not([data-theme-preference="dark"]) {
  color-scheme: light;
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme-preference="light"]):not([data-theme-preference="dark"]) {
    color-scheme: dark;
    --color-bg: #111017;
    --color-surface: #1b1922;
    --color-surface-subtle: #25222d;
    --brand-primary: color-mix(in srgb, var(--brand-primary-base) 42%, #ffffff);
    --color-primary: var(--brand-primary);
    --color-primary-strong: #b5adff;
    --brand-accent: color-mix(in srgb, var(--brand-accent-base) 52%, #ffffff);
    --color-accent: var(--brand-accent);
    --color-text: #f7f4f1;
    --color-text-muted: #b5afbd;
    --color-border: #383341;
    --color-focus: #c8c2ff;
    --color-on-primary: #17151d;
  }
}
